import { Injectable, Component, Inject } from '@angular/core';
import { DomService } from './DOMService';
import { BehaviorSubject } from 'rxjs';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SkeletonServiceService } from 'src/app/components/skeleton-service.service';
declare var $: any;
@Injectable()
export class ModalService {
  event: BehaviorSubject<boolean>;
  constructor(private domService: DomService, public dialog: MatDialog, private skeletonSrvc: SkeletonServiceService) { }

  private modalElementId = 'modal-container';
  private overlayElementId = 'overlay';
  private modalBody = 'modal-body';
  public isSuccess = false;
  public msg: any;
  public isError = false;
  public title: any;
  public subtitle: any;
  public isOpen = false;
  public closeAll$ = new BehaviorSubject<boolean>(false);
  init(component: any, inputs: any, outputs: object) {
    const componentConfig = {
      inputs: inputs,
      outputs: outputs,
    };
    // this.domService.removeComponent();
    this.domService.appendComponentTo(
      this.modalBody,
      component,
      componentConfig
    );
    document.getElementById(this.modalElementId).className = "show";
    document.getElementById(this.overlayElementId).className = "show";
  }

  openSessionExpires(){
    return this.openDialog('notification', 'ml_session_expired_reconnect_ask', true);
  }

  closeAllModals(){
    this.dialog.closeAll();
    this.closeAll$.next(true);
  }

  openNewPhoneNumberingModal(component:any, phone:string){
    const dialogRef = this.dialog.open(component, {
      minWidth: "250px",
      maxWidth: "500px",
      disableClose: true,
      panelClass: "custom-border",
      data: {
        header: 'new_numbering',
        msg: 'update_Phn_Num_Msg',
        phone
      },
    });

    return dialogRef.afterClosed().toPromise();
  }
  destroy() {
    this.domService.removeComponent();
    document.getElementById(this.modalElementId).className = 'hidden';
    document.getElementById(this.overlayElementId).className = 'hidden';
    this.msg = '';
  }
  showModal() {
    $('#successDialogue').modal('show');
    if(this.skeletonSrvc.theme.name == "lonaci")
      $('#missCIAuthModal').show('show');
  }
  openDialog(header:string, msg:string, isConfirm:boolean, isOk = false,  extraParam?: string, yesButtonLabel?: string, noButtonLabel?: string, okButtonLabel?: string,
  contentHeader?: string): Promise<any> {
    const dialogRef = this.dialog.open(DialogInterface, {
      minWidth: "250px",
      maxWidth: "500px",
      panelClass: "custom-border",
      disableClose: isConfirm,
      data: {
        yesClicked: false,
        isOk: isOk,
        header: header,
        msg: msg,
        isConfirmDialog: isConfirm,
        extraParam: extraParam || null,
        okLabel: okButtonLabel || 'OK',
        yesLabel: yesButtonLabel || 'yes',
        noLabel: noButtonLabel || 'no',
        contentHeader: contentHeader || ''
      },
    });
    return dialogRef.afterClosed().toPromise();
  }
  openDialogcmp(component: any, data): Promise<any> {
    const dialogRef = this.dialog.open(component, {
      width: '100%',
      height: '70%',
      panelClass: 'no-padding',
      data: { data },
    });
    return dialogRef.afterClosed().toPromise();
  }
}

export interface DialogData {
  yesClicked: boolean;
  isConfirmDialog: boolean;
  isOk: boolean;
  header: string;
  msg: string;
  extraParam?: string;
  buttonLabel?: string;
  contentHeader?: string;
}
@Component({
  selector: "dialog-overview-example-dialog",
  templateUrl: 'dialog.html',
})
export class DialogInterface {
  constructor(
    public modalService: ModalService,
    public dialogRef: MatDialogRef<DialogInterface>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  onNoClick(): void {
    this.data.yesClicked = false;
    this.dialogRef.close(this.data);

  }
  onYesClick(): void {
    this.data.yesClicked = true;
    this.dialogRef.close(this.data);
  }
}
